import React, {Component} from 'react';
import '../comCss/Poke.css';
import CodeBlock from '../CodeBlock';

export class VimoMeny extends Component {

    constructor(props) {
      super(props);
      this.state = {isToggleOn: true};
    
      // This binding is necessary to make `this` work in the callback
      this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState(state => ({
          isToggleOn: !state.isToggleOn
        }));
      }

    render(){ 
   return (
    <div class="mobile-meny" onClick={this.handleClick}>
            <div class="top-meny" style={this.state.isToggleOn ? {animation: 'topMeny-close-ani 0.5s both'} : {animation: 'topMeny-ani 0.5s both'} }></div>
            <div class="middle-meny" style={this.state.isToggleOn ? {animation: 'midMeny-close-ani 0.5s both'} : {animation: 'midMeny-ani 0.25s 0.25s both'}}></div>
            <div class="bottom-meny"style={this.state.isToggleOn ? {animation: 'btmMeny-close-ani 0.5s both'} : {animation: 'btmMeny-ani 0.5s both'}}></div>
        </div>
   );
 }
 }

 export class VimoCom extends Component {

   render(){ 
    const a = <VimoMeny />
    const js = `
    export class VimoMeny extends Component {

        constructor(props) {
          super(props);
          this.state = {isToggleOn: true};
        
          // This binding is necessary to make "this" work in the callback
          this.handleClick = this.handleClick.bind(this);
        }
    
        handleClick() {
            this.setState(state => ({
              isToggleOn: !state.isToggleOn
            }));
          }
    
        render(){ 
       return (
        <div class="mobile-meny" onClick={this.handleClick}>
                <div class="top-meny" style={this.state.isToggleOn ? {animation: 'topMeny-close-ani 0.5s both'} : {animation: 'topMeny-ani 0.5s both'} }></div>
                <div class="middle-meny" style={this.state.isToggleOn ? {animation: 'midMeny-close-ani 0.5s both'} : {animation: 'midMeny-ani 0.25s 0.25s both'}}></div>
                <div class="bottom-meny"style={this.state.isToggleOn ? {animation: 'btmMeny-close-ani 0.5s both'} : {animation: 'btmMeny-ani 0.5s both'}}></div>
            </div>
       );
     }
     }`

  return (
            <div>
                <p class="pws1-pro-descript">Here is a little demo for the menu I made. You can find the website i made this for through this <a href="https://www.vimomedia.com" style={{color: "#2771A6"}}>link.</a></p>
                < CodeBlock 
                code = "javascript"
                lang = "React"
                title = "Meny animation"
                playground = {a}
                js = {js}
                css = "last"
                bgColor = "#CDDDBD"
                />
            </div>
  );
}
}


export default VimoCom;
